import type { Parameter } from "@/models/Parameter";
import type { Belastingschijf } from "@/models/domain/Belastingschijf";

export const inkomstenbelastingSchijven: Parameter<Belastingschijf[]> = {
	values: {
		"2020-01-01": {
			metadata: {
				reference:
					"https://www.rijksoverheid.nl/actueel/nieuws/2019/12/17/belangrijkste-belastingwijzigingen-per-1-januari-2020",
			},
			value: [
				{ tot: 68507, tarief: 0.3735, schijf: 1 },
				{ vanaf: 68507, tarief: 0.495, schijf: 2 },
			],
		},
		"2021-01-01": {
			metadata: {
				reference:
					"https://www.consumentenbond.nl/geldgids/geldgids-uitgelicht/belastingtarieven2021",
			},
			value: [
				{ tot: 68507, tarief: 0.371, schijf: 1 },
				{ vanaf: 68507, tarief: 0.495, schijf: 2 },
			],
		},
		"2022-01-01": {
			value: [
				{ tot: 69399, tarief: 0.3707, schijf: 1 },
				{ vanaf: 69399, tarief: 0.495, schijf: 2 },
			],
		},
		"2023-01-01": {
			value: [
				{ tot: 73_031, tarief: 0.3693, schijf: 1 },
				{ vanaf: 73_031, tarief: 0.495, schijf: 2 },
			],
		},
		"2024-01-01": {
			value: [
				{ tot: 75_624, tarief: 0.3697, schijf: 1 },
				{ vanaf: 75_624, tarief: 0.495, schijf: 2 },
			],
		},
		"2025-01-01": {
			metadata: {
				reference:
					"https://web.archive.org/web/20241003122541/https://www.rijksoverheid.nl/onderwerpen/belastingplan/burgers",
			},
			value: [
				{ tot: 38_441, tarief: 0.3582, schijf: 1 },
				{ vanaf: 38_441, tot: 76_817, tarief: 0.3748, schijf: 2 },
				{ vanaf: 76_817, tarief: 0.495, schijf: 3 },
			],
		},
		"2026-01-01": {
			value: [
				{ tot: 38_883, tarief: 0.357, schijf: 1 },
				{ vanaf: 38_883, tot: 79_137, tarief: 0.3756, schijf: 2 },
				{ vanaf: 79_137, tarief: 0.495, schijf: 3 },
			],
		},
	},
};
